module.exports = __webpack_public_path__ + "img/좌측공지방배너.61763d99.png";